export interface CPSPromptData {
    p_id: string;
    title: string;
    tags: TagEnum[];
    summary: string;
    content: string;
    is_active: boolean;
    is_deleted: boolean;
}

export type TagEnum =
    | 'company'
    | 'job'
    | 'candidate'
    | 'match'
    | 'clarity'
    | 'persuasion'
    | 'seo'
    | 'tone'
    | 'diversity'
    | 'strengths'
    | 'achievements'
    | 'skills'
    | 'keywords'
    | 'vision'
    | 'culture'
    | 'values'
    | 'differentiators'
    | 'compatibility'
    | 'alignment'
    | 'culture_fit'
    | 'data_driven'
    | 'insight'
    | 'background_research';

export const tagColorMap: Record<TagEnum, string> = {
    // core entities
    company:             'bg-blue-600 text-white',
    job:                 'bg-green-600 text-white',
    candidate:           'bg-purple-600 text-white',
    match:               'bg-yellow-500 text-black',

    // content-boosters
    clarity:             'bg-teal-400 text-white',
    persuasion:          'bg-red-500 text-white',
    seo:                 'bg-indigo-500 text-white',
    tone:                'bg-pink-400 text-white',
    diversity:           'bg-emerald-500 text-white',

    // profile-specific helpers
    strengths:           'bg-green-700 text-white',
    achievements:        'bg-yellow-600 text-black',
    skills:              'bg-blue-700 text-white',
    keywords:            'bg-orange-500 text-white',

    // vision & culture
    vision:              'bg-cyan-500 text-white',
    culture:             'bg-amber-500 text-black',
    values:              'bg-lime-500 text-black',
    differentiators:     'bg-rose-500 text-white',

    // match & alignment
    compatibility:       'bg-teal-700 text-white',
    alignment:           'bg-blue-700 text-white',
    culture_fit:         'bg-pink-700 text-white',

    // data & research
    data_driven:         'bg-gray-700 text-white',
    insight:             'bg-sky-500 text-white',
    background_research: 'bg-violet-500 text-white',
};

export const TAG_ENUM_VALUES: TagEnum[] = [
    // core entities
    'company',
    'job',
    'candidate',
    'match',

    // content-boosters
    'clarity',
    'persuasion',
    'seo',
    'tone',
    'diversity',

    // profile-specific helpers
    'strengths',
    'achievements',
    'skills',
    'keywords',

    // vision & culture
    'vision',
    'culture',
    'values',
    'differentiators',

    // match & alignment
    'compatibility',
    'alignment',
    'culture_fit',

    // data & research
    'data_driven',
    'insight',
    'background_research',
];
